<template>
<div style="width: 200px">
  <!--  :defaultSelectedKeys="['010102']"
      :defaultOpenKeys="['01']" -->
    <a-menu
      :openKeys="openKeys"
      :selectedKeys="selectedKeys"
      mode="inline"
      theme="dark"
      :inlineCollapsed="collapsed"
      @openChange="onOpenChange"
      @click="selectmenu"
      >
    <template v-for="(m) in menusarr">
       <a-menu-item :key="m.name"  v-if="!m.submenus">
            <router-link :to="{path: m.linkUrl}">
             <i :class="'anticon-user anticon-'+m.icon"></i>
              <span>{{m.displayName}}</span>
            </router-link>
      </a-menu-item>
       <a-sub-menu v-else :key="m.name">
           <template slot="title">
            <i :class="'anticon-user anticon-'+m.icon"  ></i>
             <!-- <a-icon type="pie-chart" /> -->
            <span>{{m.displayName}}</span>
          </template>
          <a-menu-item v-for="submenu in m.submenus"  :key="submenu.name" >
            <router-link  :to="{path: submenu.linkUrl}">
              <span>{{submenu.displayName}}</span>
            </router-link>
          </a-menu-item>
       </a-sub-menu>
      </template>
    </a-menu>
  </div>
</template>
<script>
import menuBus from "@/mixins/menuBus";
export default {
  name: 'hp-manager-menu',
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
    menusarr: {
      type: Array,
      default () {
        return [1,2];
      },
    },
  },
  data(){
    return {
      rootSubmenuKeys:[],
       openKeys: ['workbench'],
       selectedKeys:['homepage']
    // collapsed:true,
     // menusarr:this.menus
      
    }
  },

  mounted(){
    let a=this.menusarr.filter(item=> item.parentName=='')
    a.map(res=>{
      this.rootSubmenuKeys.push(res.name)
    })
    menuBus.$off("checkmenu");
    menuBus.$on('checkmenu',(openKeys,checkKeys) => {
      this.openKeys=openKeys
      this.selectedKeys = checkKeys
    })
    
  },
  methods:{
    toggleCollapsed(){

    },
    selectmenu(item, key, keyPath ){
      this.selectedKeys = [item.key]
    },
    onOpenChange (openKeys) {
      const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1)
      if (!this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : []
      }
    },
  }
}
</script>

<style lang="scss">
  @import "../../assets/scss/output.scss";

  // @include b(menu) {
  .el-menu {
    a{
      display: block;
      color: #fff;
    }
    i{
      color: #fff;
    }
    .is-router{
      color: #ffd04b;
      i{
        color: #ffd04b;
      }
    }
  }
  .ant-menu-inline-collapsed > .ant-menu-item .anticon + span, .ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .anticon + span, .ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .anticon + span, .ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .anticon + span,
  .ant-menu-inline-collapsed > .ant-menu-item .anticon-user + span, .ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .anticon-user + span, .ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .anticon-user + span, .ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .anticon-user + span{
max-width: 0;
    display: inline-block;
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/navigation/menu.vue